import { useApi } from './api';
import { readJsonResponse, type ApiResult } from './apiResponse';
import type {
  AuditLogPurgeCronConfigDto,
  AuditLogPurgeCronConfigUpdateDto,
  AuditLogPurgeRunDto,
  SpringPage
} from '../types/auditLogPurge';

export type { ApiOk, ApiErr, ApiResult } from './apiResponse';

export const useAuditLogPurgeService = () => {
  const { apiFetch } = useApi();
  const base = '/admin/audit-log-purge';

  const getCronConfig = async (): Promise<ApiResult<AuditLogPurgeCronConfigDto>> => {
    try {
      const res = await apiFetch(`${base}/cron-config`);
      return readJsonResponse<AuditLogPurgeCronConfigDto>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  const updateCronConfig = async (
    body: AuditLogPurgeCronConfigUpdateDto
  ): Promise<ApiResult<AuditLogPurgeCronConfigDto>> => {
    try {
      const res = await apiFetch(`${base}/cron-config`, {
        method: 'PUT',
        body: JSON.stringify(body)
      });
      return readJsonResponse<AuditLogPurgeCronConfigDto>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  const runManualPurge = async (): Promise<ApiResult<AuditLogPurgeRunDto>> => {
    try {
      const res = await apiFetch(`${base}/run`, { method: 'POST' });
      return readJsonResponse<AuditLogPurgeRunDto>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  const getRuns = async (page: number, size: number): Promise<ApiResult<SpringPage<AuditLogPurgeRunDto>>> => {
    try {
      const params = new URLSearchParams({
        page: String(page),
        size: String(size),
        sort: 'startedAt,desc'
      });
      const res = await apiFetch(`${base}/runs?${params.toString()}`);
      return readJsonResponse<SpringPage<AuditLogPurgeRunDto>>(res);
    } catch (e) {
      return {
        ok: false,
        status: 0,
        data: null,
        error: e instanceof Error ? e.message : 'Error de conexión'
      };
    }
  };

  return { getCronConfig, updateCronConfig, runManualPurge, getRuns };
};
